<common-confirm></common-confirm>
<div class="heading">
    <button mat-raised-button color="primary" (click)="add()">Add shipment</button>
</div>
<div class="container-columns">
    <div class="left">
        <mat-card class="drag-bag order-items">
            <div class="title">
                <mat-checkbox [checked]="allFreeItemsSelected"
                              class="pull-left"
                              (change)="selectAll($event, items)">
                    Order items ({{ items.length }})
                </mat-checkbox>
            </div>

            <div class="items free" *ngIf="items && items.length; else noItems"
                 [dragula]='bagName' [(dragulaModel)]="items">
                <div class="item id-{{item.id}}" *ngFor="let item of (items || [])">
                    <mat-checkbox [value]="item.id"
                                  [checked]="selectedList.indexOf(item.id) > -1"
                                  (change)="selectedListUpdate($event)">
                        {{ item.item }} (sn: {{ item.serial }}) (ref2: {{ item.ref2 }}). qty: {{ item.quantity }}
                    </mat-checkbox>
                </div>
            </div>
            <ng-template #noItems>
                <div class="items free text-center padding-top-10" [dragula]='bagName' [(dragulaModel)]="items">No not
                    linked items
                </div>
            </ng-template>
        </mat-card>
    </div>
    <div class="right" *ngIf="shipments">
        <div class="row flex flex-end align-center">
            <div>
                <mat-form-field class="margin-bottom-0">
                    <input type="text" matInput placeholder="Search" #shipmentSearch>
                </mat-form-field>
            </div>
            <div>
                <mat-checkbox #showOnlyEmpty>Only empty</mat-checkbox>
            </div>
        </div>

        <div class="shipments" #scrollContainer>
            <ng-container
                    *ngFor="let shipment of shipments | filter: 'ref' : 'like' : shipmentSearch.value; let i = index">
                <mat-card class="drag-bag shipment"
                          *ngIf="(showOnlyEmpty.checked && shipment.order_items.length === 0) || !showOnlyEmpty.checked">

                    <div class="title">
                        <mat-checkbox [checked]="allShipmentItemsSelected[i]"
                                      class="pull-left"
                                      (change)="selectAll($event, shipment.order_items)">
                            {{ shipment.ref }}<span *ngIf="shipment.weight">, ({{ shipment.weight }}kg)</span>
                        </mat-checkbox>

                        <button mat-icon-button (click)="edit(shipment)">
                            <mat-icon title="Edit">edit</mat-icon>
                        </button>
                    </div>

                    <mat-divider></mat-divider>

                    <div class="items box id-{{shipment.id}}" [dragula]='bagName'
                         [(dragulaModel)]="shipment.order_items">
                        <div class="item id-{{item.id}}" *ngFor="let item of shipment.order_items">
                            <mat-checkbox [value]="item.id"
                                          [checked]="selectedList.indexOf(item.id) > -1"
                                          (change)="selectedListUpdate($event)">
                                {{ item.item }} (sn: {{ item.serial }}) (ref2: {{ item.ref2 }}).
                                qty: {{ item.quantity }}
                            </mat-checkbox>

                        </div>
                    </div>
                </mat-card>
            </ng-container>
        </div>
    </div>
</div>
